// extracted by mini-css-extract-plugin
module.exports = {"tools":"WorkTypesPage_tools__3jK3Y","mobileTools":"WorkTypesPage_mobileTools__29WGs","page":"WorkTypesPage_page__2QYbS","right":"WorkTypesPage_right__1BMrD"};